import './Overlay.8868a82e50910173a3569ef0751d85a3.css';
export default {"overlay":"_overlay_ykfnl_1"};